import styles from './Payments.module.css';

export function StatusChip({ displayStatus }: { displayStatus: string }) {
  const status = displayStatus === 'PENDING_APPROVAL' ? 'REQUESTED' : displayStatus;
  const tone = /REJECTED|PAYEE_NOT_READY|OVERDUE/.test(status)
    ? 'red'
    : /VOID|NOT_DUE/.test(status)
      ? 'grey'
      : /APPROVED/.test(status)
        ? 'blue'
        : /PAID|VERIFIED|ON_TRACK/.test(status) && !/PART_PAID/.test(status)
          ? 'green'
          : 'amber';
  const text =
    status === 'CLAIMED'
      ? 'Being verified'
      : status === 'WITHDRAWN'
        ? 'Withdrawn'
        : ['REQUESTED', 'APPROVED', 'PAID', 'REJECTED', 'VOID'].includes(status)
          ? status === 'VOID'
            ? 'Cancelled'
            : status.charAt(0) + status.slice(1).toLowerCase()
          : status.replace(/_/g, ' ');
  return (
    <span className={`${styles.statusChip} ${styles[tone]}`} data-tone={tone}>
      {text}
    </span>
  );
}
